module.exports = __webpack_public_path__ + "static/media/JO.8f719a67.svg";